"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _LinkList = _interopRequireDefault(require("@kiwicom/orbit-components/lib/LinkList"));
var _Collapse = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Collapse"));
var _Box = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Box"));
var _Badge = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Badge"));
var _Separator3 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Separator"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _SidePanelButtonLink = _interopRequireDefault(require("../SidePanelButtonLink"));
var _SidePanelSeparator2 = _interopRequireDefault(require("../SidePanelSeparator"));
var _context = require("../../../../services/auth/context");
var _context2 = require("../../../../services/brand/context");
var events = _interopRequireWildcard(require("../../consts/events"));
var _context3 = require("../../../../services/log/context");
var _useGetUser = _interopRequireDefault(require("../../components/useGetUser"));
var _context4 = require("../../../../services/intl/context");
var _context5 = require("../../services/context");
var _usePublishLogoutClicked = _interopRequireDefault(require("../../../../components/MagicLogin/consts/events/business/usePublishLogoutClicked"));
var _jsxRuntime = require("react/jsx-runtime");
var _FormattedMessage, _Separator, _FormattedMessage2, _FormattedMessage3, _FormattedMessage4, _FormattedMessage5, _FormattedMessage6, _FormattedMessage7, _FormattedMessage8, _FormattedMessage9, _FormattedMessage10, _Separator2, _FormattedMessage11, _SidePanelSeparator;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const LoggedPanelLinks = _ref => {
  var _user$unreadMessages;
  let {
    children
  } = _ref;
  const user = (0, _useGetUser.default)();
  const {
    onSignOut,
    logOut,
    isSkyUsersV2
  } = (0, _context.useAuth)();
  const {
    isFareLocksLinkShown,
    isReferAFriendShown
  } = (0, _context5.useNavConfig)();
  const {
    log
  } = (0, _context3.useLog)();
  const intl = (0, _reactIntl.useIntl)();
  const {
    language
  } = (0, _context4.useIntl)();
  const {
    company_name: companyName
  } = (0, _context2.useBrand)();
  const unreadMessages = (_user$unreadMessages = user === null || user === void 0 ? void 0 : user.unreadMessages) !== null && _user$unreadMessages !== void 0 ? _user$unreadMessages : 0;
  const publishLogoutClicked = (0, _usePublishLogoutClicked.default)();
  const handleSignOut = () => {
    log(events.CLICK_ON_SIGN_OUT, {});
    if (isSkyUsersV2) {
      publishLogoutClicked();
      return logOut();
    }
    return onSignOut();
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
        href: `/${language.id}/user/?tab=trips`,
        onClick: () => log(events.VISIT_MY_TRIPS, {}),
        spaceAfter: "small",
        children: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "navbar.account.my_trips"
        }))
      })
    }), _Separator || (_Separator = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Separator3.default, {
      spaceAfter: "small"
    })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
      direction: "row",
      align: "center",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
        href: `/${language.id}/user/?tab=inbox`,
        onClick: () => log(events.VISIT_INBOX, {}),
        children: _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account_v2.inbox.heading.title"
        }))
      }), unreadMessages > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Badge.default, {
        dataTest: "TopNav-UnreadMessagesBadge",
        type: "criticalSubtle",
        children: unreadMessages
      })]
    }), isFareLocksLinkShown && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
        href: `/${language.id}/user/?tab=locked-prices`,
        onClick: () => log(events.VISIT_FARE_LOCKS, {}),
        children: _FormattedMessage3 || (_FormattedMessage3 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "navbar.account.locked_prices"
        }))
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
        href: `/${language.id}/user/?tab=price-alerts`,
        onClick: () => log(events.VISIT_PRICE_ALERTS, {}),
        children: _FormattedMessage4 || (_FormattedMessage4 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "navbar.account.price_alerts"
        }))
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
        href: `/${language.id}/user/?tab=wallet`,
        onClick: () => log(events.VISIT_KIWICOM_CREDITS, {}),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "navbar.account.wallet",
          values: {
            companyName
          }
        })
      })
    }), isReferAFriendShown && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
        href: `/${language.id}/user/?tab=refer-friend`,
        onClick: () => log(events.VISIT_REFER_FRIEND, {}),
        children: _FormattedMessage5 || (_FormattedMessage5 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account_v2.components.refer_friend"
        }))
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      margin: {
        top: "150"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Collapse.default, {
        onClick: () => {
          log(events.CLICK_ON_PREFERENCES, {});
        },
        customLabel: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          as: "span",
          weight: "medium",
          children: intl.formatMessage({
            id: "navbar.account.preferences"
          })
        }),
        expandButtonLabel: intl.formatMessage({
          id: "orbit.collapse_expand"
        }),
        collapseButtonLabel: intl.formatMessage({
          id: "orbit.collapse_collapse"
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LinkList.default, {
          indent: true,
          spacing: "none",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
            href: `/${language.id}/user/settings/?tab=settings`,
            children: _FormattedMessage6 || (_FormattedMessage6 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "navbar.account.account_settings"
            }))
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
            href: `/${language.id}/user/settings/?tab=travelers`,
            onClick: () => log(events.VISIT_SAVED_TRAVELERS, {}),
            children: _FormattedMessage7 || (_FormattedMessage7 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "navbar.account.saved_travelers"
            }))
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
            href: `/${language.id}/user/settings/?tab=privacy-security`,
            onClick: () => log(events.VISIT_PRIVACY_SECURITY, {}),
            children: _FormattedMessage8 || (_FormattedMessage8 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "navbar.account.privacy_security"
            }))
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
            href: `/${language.id}/user/settings/?tab=payment`,
            onClick: () => log(events.VISIT_PAYMENT_METHODS, {}),
            children: _FormattedMessage9 || (_FormattedMessage9 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "navbar.account.payment_methods"
            }))
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
            href: `/${language.id}/user/settings/?tab=billing`,
            onClick: () => log(events.VISIT_BILLING_ADDRESSES, {}),
            children: _FormattedMessage10 || (_FormattedMessage10 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "navbar.account.billing_addresses"
            }))
          })]
        })
      })
    }), _Separator2 || (_Separator2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Separator3.default, {
      spaceAfter: "small"
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
        onClick: handleSignOut,
        spaceAfter: "large",
        children: _FormattedMessage11 || (_FormattedMessage11 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "navbar.header.sign_out"
        }))
      })
    }), _SidePanelSeparator || (_SidePanelSeparator = /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelSeparator2.default, {})), children]
  });
};
var _default = exports.default = LoggedPanelLinks;